import jwt_decode from "jwt-decode";

import setAuthHeader from "./set-auth-header";

const checkAuthState = () => {
  const token = localStorage.getItem("token");

  if (token) {
    setAuthHeader(token);

    return { token, ...jwt_decode(token) };
  } else {
    return { token: null, _id: null, email: null, name: null };
  }
};

export default checkAuthState;
